import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const ExportFileIcon: React.FC<
  SvgIconProps & { text?: string; isDeleted?: boolean }
> = ({ fill, text, isDeleted, style, ...props }) => {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 29 40'
      fill='none'
      style={{ color: 'transparent', ...style }}
    >
      <g id='g202'>
        <g style={{ fill: 'none' }} id='g31' transform='translate(6,21)'>
          <path id='rect20' style={{ fill: '#FFF' }} d='M 0,0 H 15 V 1 H 0 Z' />
        </g>
        <g style={{ fill: 'none' }} id='g43' transform='translate(6,18)'>
          <text
            style={{
              fontFamily: 'Proxima Nova Rg',
              fontSize: 8,
              height: 11,
              fill: '#FFF',
            }}
          >
            {text}
          </text>
        </g>
        <g style={{ fill: 'none' }} id='g44' transform='translate(6,27)'>
          <path id='rect33' style={{ fill: '#FFF' }} d='M 0,0 H 9 V 1 H 0 Z' />
        </g>
        <g style={{ fill: 'none' }} id='g31-0' transform='translate(6,24)'>
          <path
            id='rect20-2'
            style={{ fill: '#FFF' }}
            d='M 0,0 H 15 V 1 H 0 Z'
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default ExportFileIcon;
